import FindLocationResultState from '../data/schema/FindLocationResultState';
import { action } from 'satcheljs/lib/legacy';

/**
 * Sets the IsSearching state for the find location control
 */
export default action('setIsSearching')(function setIsSearching(
    viewstate: FindLocationResultState,
    isSearching: boolean
) {
    viewstate.isSearching = isSearching;
});
